import { Button, ErrorState } from "@cmde/shadcn";
import { NetworkIcon, RotateCwIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ErrorSeasonsList({ retry, errorMessage }: { retry: () => void; errorMessage?: string }) {
  const { t } = useTranslation();

  return (
    <ErrorState
      title={t("seasons.list.general.error_fetching_seasons")}
      description={errorMessage ?? t("seasons.list.general.error_description")}
      icon={<NetworkIcon />}
    >
      <Button onClick={retry}> <RotateCwIcon /> {t("seasons.list.general.retry")}</Button>
    </ErrorState>
  );
}
